var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-select",
    {
      attrs: {
        "popper-class": "yxtbiz-grade-select",
        "value-key": "id",
        "prop-label": "name",
        clearable: true,
        "collapse-tags": true,
        multiple: "",
      },
      on: { clear: _vm.clear, change: _vm.change, "remove-tag": _vm.removeTag },
      model: {
        value: _vm.selected,
        callback: function ($$v) {
          _vm.selected = $$v
        },
        expression: "selected",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "lh44",
          attrs: { slot: "fixed-header" },
          slot: "fixed-header",
        },
        [
          _c(
            "yxt-checkbox",
            {
              on: { change: _vm.changeAll },
              model: {
                value: _vm.isAll,
                callback: function ($$v) {
                  _vm.isAll = $$v
                },
                expression: "isAll",
              },
            },
            [_vm._v(_vm._s(_vm.$t("pc_biz_udp_lbl_selectAll")))]
          ),
        ],
        1
      ),
      _vm._l(_vm.grades, function (item, index) {
        return _c(
          "yxt-option",
          {
            key: index,
            staticStyle: {
              height: "auto",
              "max-height": "200px",
              overflow: "auto",
            },
            attrs: { value: item, label: item.name },
          },
          [
            _c(
              "yxt-checkbox",
              {
                attrs: {
                  "change-text-color": true,
                  value: _vm.testChecked(item),
                },
                on: {
                  change: function ($event) {
                    return _vm.changeGrade($event, item)
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(item.name) + "\n    ")]
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }